// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3QxGW","choiceBoxes":"toolbarselects_choiceBoxes__2nlgt","simpleField":"toolbarselects_simpleField__1xIk0"};